import { createSlice } from "@reduxjs/toolkit";

export const noteSlice = createSlice({
    name: "note",
    initialState: {
        note: "",
        isEditing: false,
    },
    reducers: {
        setNote: (state,action)=>{
            state.note = action.payload
        },
        startEditing: (state)=>{
            state.isEditing = true
        },
        cancelEditing: (state, action)=>{
            state.isEditing = false
            state.note = action.payload || "";
        },
        saveNote: (state)=>{
            console.log("Saved Note:", state.note)
            state.isEditing =false
        }
    }
})

const {actions, reducer: questionCardReducer}= noteSlice
export const {setNote, startEditing, cancelEditing, saveNote} = actions
export default questionCardReducer